import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert
  } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { fetchAreaRequest, createAreaRequest, editAreaRequest } from "../../../api/area";

class AreaForm extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      resource: {
        areaName: ''
      },
      error: null
    }
  }

  componentDidMount() {

    const { instanceId } = this.props;

    if (instanceId) {
      this.fetchInstance(instanceId);
    } 
  }

  fetchInstance = (id) => {
      fetchAreaRequest(id,
          result => this.setState(prevState => ({
              resource: {
                  ...prevState.resource,
                  ...result
              }
          })), error => this.setState({ error: 'There was an error' }));
  }

  handleFormChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [name]: value,
      },
    }))
  }

  save = () => {
    const {
      areaName
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    let data = {
        areaName
    };

    if (isNewRecord) {
        createAreaRequest(data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    } else {
        editAreaRequest(instanceId, data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    }
  }

  saveSuccess = () => {
    this.setState({ error: null });
    this.props.goToList('area');
  }

  saveFailure = (error) => {
      this.setState({ error: error.message ||'There was an error saving Area.' })
  }

  render() {

    const {
        areaName
    } = this.state.resource;

    const {
        error
    } = this.state;

    const {
      instanceId,
    } = this.props;

    const isNewRecord = !instanceId;

    return (
      <Row>
        <Col md={12}>
          <Card
            title={isNewRecord ? "New entry" : "Edit entry"}
            content={
              <form>
                <Button className="card-top-btn btn-primary" onClick={() => this.props.goToList('area')}>
                  Back to List
                </Button>
                <FormGroup>
                  <ControlLabel>Area Name <span className="required-star">*</span></ControlLabel>
                  <FormControl
                    type="text"
                    name="areaName"
                    value={areaName}
                    onChange={this.handleFormChange}
                    placeholder=""
                  />
                </FormGroup>

                {error &&
                  <Alert bsStyle="danger">
                    {error}
                  </Alert>
                }


                <Button bsStyle="primary" pullRight fill onClick={this.save}>
                  {isNewRecord ? "Create" : "Save changes"}
                </Button>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    )
  }
}

export default AreaForm;
